import { gql } from '@apollo/client';
import LABEL_FRAGMENT from '../fragments/labels';

const BIODIRECT_INFO_DRAWER_QUERY = gql`
  query biofluxDirect($biodirectId: ID!) {
    biofluxDirect(biodirectId: $biodirectId) {
      id
      senderInformation {
        id
        latestLabel {
          ...LabelFragment
        }
      }
      recipientInformation {
        id
        latestLabel {
          ...LabelFragment
        }
      }
    }
  }

  ${LABEL_FRAGMENT}
`;

export default BIODIRECT_INFO_DRAWER_QUERY;
